var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('PageTitle',[_vm._v("\n    Email #"+_vm._s(_vm.message.id)+"\n  ")]),_vm._v(" "),_c('MessageCard',{attrs:{"message":_vm.message}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }